var shared = require('../internals/shared');
var uid = require('../internals/uid');

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/shared-key.js
// module id = 481
// module chunks = 1